(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lang = (document.documentElement.lang || '').toLowerCase();
  const isEN = lang.startsWith('en');
  const isPT = lang.startsWith('pt');

  /* ---------- Judge.me: su interfaz viene en español; la traducimos en PT/EN ---------- */
  const JM = {
    'Reseñas de Clientes': ['Avaliações de clientes', 'Customer Reviews'],
    'Escribir una reseña': ['Escrever uma avaliação', 'Write a review'],
    'Más': ['Mais', 'More'],
    'Filtros': ['Filtros', 'Filters'],
    'Más Recientes': ['Mais recentes', 'Most Recent'],
    'Mayor Calificación': ['Melhor classificação', 'Highest Rating'],
    'Menor Calificación': ['Pior classificação', 'Lowest Rating'],
    'Solo Imágenes': ['Só imagens', 'Only Pictures'],
    'Imágenes Primero': ['Imagens primeiro', 'Pictures First'],
    'Videos Primero': ['Vídeos primeiro', 'Videos First'],
    'Más Útiles': ['Mais úteis', 'Most Helpful'],
    '¿Cómo calificarías este producto?': ['Como classificaria este produto?', 'How would you rate this product?'],
    'Nos encantaría que compartieras un poco sobre tu experiencia.': ['Gostaríamos que partilhasse um pouco da sua experiência.', "We'd love you to share a little about your experience."],
    'Contenido de la reseña (Obligatorio)': ['Conteúdo da avaliação (obrigatório)', 'Review content (required)'],
    'Solo te contactaremos sobre tu reseña si es necesario. Al enviar tu reseña, aceptas nuestros': ['Só o contactaremos sobre a sua avaliação se for necessário. Ao enviar a sua avaliação, aceita os nossos', "We'll only contact you about your review if necessary. By submitting your review, you agree to our"],
    'términos y condiciones': ['termos e condições', 'terms and conditions'],
    'y': ['e', 'and'],
    'política de privacidad': ['política de privacidade', 'privacy policy'],
    'Sobre ti': ['Sobre si', 'About you'],
    'Por favor, cuéntanos más sobre ti.': ['Conte-nos um pouco mais sobre si.', 'Please tell us more about you.'],
    'Dirección de correo electrónico (Obligatorio)': ['Endereço de email (obrigatório)', 'Email address (required)'],
    'Respetamos tu privacidad.': ['Respeitamos a sua privacidade.', 'We respect your privacy.'],
    'Nombre (Obligatorio)': ['Nome (obrigatório)', 'Name (required)'],
    'No será visible para otros clientes.': ['Não será visível para outros clientes.', "It won't be visible to other customers."],
    'Reseña como anónimo': ['Avaliar de forma anónima', 'Review anonymously'],
    'Compartir una foto o video': ['Partilhar uma foto ou vídeo', 'Share a photo or video'],
    'Sube una foto o video para apoyar tu reseña.': ['Carregue uma foto ou vídeo para acompanhar a sua avaliação.', 'Upload a photo or video to support your review.'],
    'Haz clic para subir': ['Clique para carregar', 'Click to upload'],
    'o arrastrar y soltar': ['ou arraste e largue', 'or drag and drop'],
    'Atrás': ['Voltar', 'Back'],
    'Siguiente': ['Seguinte', 'Next'],
    'Cerrar': ['Fechar', 'Close'],
    '¡Gracias por tu reseña!': ['Obrigado pela sua avaliação!', 'Thank you for your review!'],
    'La estamos procesando y aparecerá en la tienda pronto.': ['Estamos a processá-la e aparecerá na loja em breve.', "We're processing it and it will appear in the store soon."],
    'Por favor, confirma tu correo electrónico haciendo clic en el enlace que acabamos de enviarte. Esto nos ayuda a mantener las reseñas auténticas.': ['Confirme o seu email clicando no link que acabámos de lhe enviar. Isto ajuda-nos a manter as avaliações autênticas.', "Please confirm your email by clicking the link we've just sent you. This helps us keep reviews authentic."]
  };
  const PH = {
    'Empieza a escribir aquí...': ['Comece a escrever aqui...', 'Start writing here...'],
    'Tu dirección de correo electrónico': ['O seu endereço de email', 'Your email address'],
    'Nombre': ['Nome', 'Name'],
    'Pega tu URL de Youtube aquí': ['Cole aqui o URL do YouTube', 'Paste your YouTube URL here']
  };
  if (isPT || isEN) {
    const idx = isPT ? 0 : 1;
    const RX = [[/^(\d+) reseñas?$/, isPT ? '$1 avaliações' : '$1 reviews']];
    const tr = (s) => {
      const t = s.trim();
      if (!t) return null;
      if (Object.prototype.hasOwnProperty.call(JM, t)) return s.replace(t, JM[t][idx]);
      for (const [rx, rep] of RX) if (rx.test(t)) return s.replace(t, t.replace(rx, rep));
      return null;
    };
    const walk = (root) => {
      if (!root) return;
      const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (n.parentElement && /^(SCRIPT|STYLE|NOSCRIPT)$/.test(n.parentElement.tagName)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      const nodes = [];
      while (w.nextNode()) nodes.push(w.currentNode);
      nodes.forEach((n) => { const r = tr(n.nodeValue); if (r !== null && r !== n.nodeValue) n.nodeValue = r; });
    };
    const scope = () => document.querySelectorAll('.jm-review-widget, .jdgm-widget, .jdgm-review-widget-modal, [class*="jdgm"], [class*="jm-"]');
    const fixPH = () => {
      document.querySelectorAll('[placeholder]').forEach((el) => {
        const v = el.getAttribute('placeholder');
        if (v && Object.prototype.hasOwnProperty.call(PH, v) && el.closest('[class*="jdgm"], [class*="jm-"]')) el.setAttribute('placeholder', PH[v][idx]);
      });
    };
    const run = () => { scope().forEach(walk); fixPH(); };
    run();
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      setTimeout(() => { pending = false; run(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Localiza el bloque de compra ---------- */
  const buyTarget = () =>
    document.querySelector('[data-zv-perso]') ||
    document.querySelector('variant-selects, variant-radios') ||
    document.querySelector('product-form') ||
    document.querySelector('[id^="MainProduct-"]');

  const scrollToBuy = () => {
    const target = buyTarget();
    if (!target) return false;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    target.classList.remove('zv-pulse');
    void target.offsetWidth;
    target.classList.add('zv-pulse');
    setTimeout(() => target.classList.remove('zv-pulse'), 1400);
    const name = document.querySelector('[data-zv-name]');
    if (name && !name.value.trim()) setTimeout(() => name.focus({ preventScroll: true }), reduceMotion ? 0 : 500);
    return true;
  };

  document.addEventListener('click', (event) => {
    const buyLink = event.target.closest('[data-zv-scroll-buy]');
    if (buyLink && buyTarget() && document.querySelector('product-form')) {
      event.preventDefault();
      scrollToBuy();
      return;
    }

    const sizeLink = event.target.closest('[data-zv-open-media]');
    if (sizeLink) {
      const id = sizeLink.getAttribute('data-zv-open-media');
      const opener =
        (id && document.querySelector(`.product__media-toggle[data-media-id="${id}"]`)) ||
        Array.from(document.querySelectorAll('.product__media-toggle[data-media-id]')).pop();
      if (opener) {
        event.preventDefault();
        opener.click();
      }
      return;
    }

    const toggle = event.target.closest('.zv-cmp__toggle');
    if (toggle) {
      const row = toggle.closest('.zv-cmp__row');
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      row.classList.toggle('is-open', open);
      const detail = row.querySelector('.zv-cmp__detail');
      if (detail) detail.setAttribute('aria-hidden', String(!open));
    }
  });

  /* ---------- Aparición suave de la comparativa ---------- */
  const reveals = document.querySelectorAll('.zv-reveal');
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((el) => el.classList.add('is-inview'));
    } else {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );
      reveals.forEach((el) => io.observe(el));
    }
  }

  /* ---------- Barra fija de compra ---------- */
  const sticky = document.querySelector('[data-zv-sticky]');
  const form = document.querySelector('product-form');
  if (sticky && form) {
    sticky.hidden = false;
    const submit = form.querySelector('[name="add"]') || form;
    const footer = document.querySelector('.footer, footer');
    let formVisible = true;
    let footerVisible = false;
    let passedForm = false;

    const render = () => {
      const show = !formVisible && passedForm && !footerVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelectorAll('a, button').forEach((el) => (el.tabIndex = show ? 0 : -1));
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === submit) {
          formVisible = entry.isIntersecting;
          passedForm = entry.boundingClientRect.top < 0;
        } else {
          footerVisible = entry.isIntersecting;
        }
      });
      render();
    });
    io.observe(submit);
    if (footer) io.observe(footer);

    const priceEl = sticky.querySelector('[data-zv-sticky-price]');
    const variantEl = sticky.querySelector('[data-zv-sticky-variant]');
    const stickyBtn = sticky.querySelector('[data-zv-sticky-btn]');
    const stickyLabel = stickyBtn && stickyBtn.querySelector('[data-zv-sticky-label]');
    const nameInput = document.querySelector('[data-zv-name]');
    const numInput = document.querySelector('[data-zv-num]');

    const ready = () => (!nameInput || nameInput.value.trim()) && (!numInput || numInput.value.trim());
    const syncLabel = () => {
      if (!stickyBtn || !stickyLabel) return;
      stickyLabel.textContent = ready() ? stickyBtn.getAttribute('data-label-add') : stickyBtn.getAttribute('data-label-choose');
    };
    const syncVariant = () => {
      const selects = document.querySelector('variant-selects, variant-radios');
      if (!selects) return;
      const checked = selects.querySelector('input[type="radio"]:checked');
      if (variantEl && checked) variantEl.textContent = `${variantEl.getAttribute('data-label') || ''} · ${checked.value}`;
      const mainPrice = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
      if (priceEl && mainPrice && mainPrice.textContent.trim()) priceEl.textContent = mainPrice.textContent.trim();
    };

    document.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects, variant-radios')) return;
      setTimeout(syncVariant, 350);
    });
    [nameInput, numInput].forEach((el) => el && el.addEventListener('input', syncLabel));

    if (stickyBtn) {
      stickyBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const addButton = form.querySelector('[name="add"]');
        if (ready() && addButton && !addButton.disabled) {
          addButton.click();
        } else {
          scrollToBuy();
        }
      });
    }
    syncVariant();
    syncLabel();
    render();
  }
})();
